export const BannerEvo = () => {
  return (
    <section id='Section Evo'>
      <div className='banner-evo'>
        <div className='banner__content'>
          <div className='txt'>
            <div className='txt__content'>
              <h1>
                LA EVOLUCIÓN <br></br>DE UNA LEYENDA
              </h1>
              <div className='logo-lippi'>
                <img
                  src='https://res.cloudinary.com/lippi-outdoor/image/upload/v1681484748/logo-evo-opt_jolmiz.png'
                  alt='vulcano'
                ></img>
              </div>
            </div>
          </div>
          <div className='btn-white'>
            <a
              href='https://www.lippioutdoor.com/bravo-evo.html'
              target='_parent'
              id='btn-banner'
            >
              Productos
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}
